const DEVELOPMENT = false;

let server = DEVELOPMENT ? 'http://localhost:4000' : 'https://instaclone.vector2912.repl.co';

export {
  server
}
